function ClientPortal() {
  return <main><h1>Client Portal Page</h1></main>;
}

export default ClientPortal;
